import React, { useEffect } from 'react';
import axios from 'axios';

export default function RevShare() {

	const redirectToRevShareUrl = async () => {
		const reqObject = await axios.get(`${import.meta.env.VITE_ROOT_PATH}/api/url/rev-share`);
		const { data: { url }} = reqObject;

		window.location.replace(url);
	}

	useEffect(() => {
		redirectToRevShareUrl();
	}, [])

	return <div></div>
}
